import { motion } from 'framer-motion';

export default function ProductsHero() {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 pt-20 sm:pt-32 pb-12 sm:pb-24 overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0">
        <div className="absolute top-5 sm:top-20 right-5 sm:right-20 w-32 h-32 sm:w-96 sm:h-96 bg-gradient-to-br from-emerald-500/15 to-transparent rounded-full blur-2xl sm:blur-3xl"></div>
        <div className="absolute bottom-5 sm:bottom-20 left-5 sm:left-20 w-32 h-32 sm:w-96 sm:h-96 bg-gradient-to-br from-teal-500/15 to-transparent rounded-full blur-2xl sm:blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 text-center relative z-10">
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-block text-xs sm:text-sm font-semibold text-emerald-400 tracking-wider uppercase mb-3 sm:mb-6 px-3 sm:px-4 py-1.5 sm:py-2 bg-emerald-500/10 rounded-full border border-emerald-500/30"
        >
          Nos Produits LED
        </motion.span>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4"
        >
          Solutions LED <span className="bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">Industrielle & Tertiaires</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-sm sm:text-base text-gray-300 mb-2 sm:mb-3 max-w-2xl mx-auto"
        >
          Conformes BAT-EQ-127 • 185 lm/W • Garantie 5 ans
        </motion.p>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="text-[10px] sm:text-xs text-emerald-400 italic"
        >
          Photos non contractuelles
        </motion.p>
      </div>
    </section>
  );
}
